// styles and images
import { useEffect, useState } from "react";
import { projectStore } from "../../store/Store";
import "./Project.css";

export default function FiscalTotals() {
  // global
  const projectTotals = projectStore((data) => data.projectTotals);
  const projectSandRates = projectStore((data) => data.projectSandRates);
  const projectLoads = projectStore((data) => data.projectLoads);
  const projectAssetLoads = projectStore((data) => data.projectAssetLoads);

  const [allVendorTotals, setAllVendorTotals] = useState();

  useEffect(() => {
    let tots = {
      invoiced_loads: 0,
      remaining_loads: 0,
      invoiced_weight: 0,
      remaining_weight: 0,
      total_invoiced: 0,
      remaining_to_invoice: 0,
    };
    if (projectTotals.vendor_totals) {
      projectTotals.vendor_totals.forEach((t) => {
        if (!t.is_sand) {
          tots.invoiced_loads = tots.invoiced_loads + t.invoiced_loads;
          tots.remaining_loads = tots.remaining_loads + t.remaining_loads;
          tots.invoiced_weight = tots.invoiced_weight + t.invoiced_weight;
          tots.remaining_weight = tots.remaining_weight + t.remaining_weight;
          tots.total_invoiced = tots.total_invoiced + t.total_invoiced;
          tots.remaining_to_invoice =
            tots.remaining_to_invoice + t.remaining_to_invoice;
        }
      });
    }
    setAllVendorTotals(tots);
  }, [projectTotals.vendor_totals]);

  const getTerminalName = (poNumber) => {
    if (projectLoads) {
      const idx = projectLoads.findIndex((x) => x.po_number === poNumber);
      if (idx > -1) {
        return projectLoads[idx].terminal_name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const getFreightAdjustments = () => {
    if (projectTotals) {
      let vendAdj = 0;
      if (projectTotals.vendor_totals) {
        projectTotals.vendor_totals.forEach((v) => {
          vendAdj = vendAdj + v.credits - v.debits;
        });
      }
      const adj =
        projectTotals.project_totals.customer_debits -
        projectTotals.project_totals.customer_credits +
        vendAdj;
      return adj;
    } else {
      return 0;
    }
  };

  const getFreightMargin = () => {
    const adj = getFreightAdjustments();
    const adjProfit = projectTotals.project_totals.profit + adj;
    if (projectTotals.project_totals.total_rev !== 0 && adjProfit !== 0) {
      const adjMargin = adjProfit / projectTotals.project_totals.total_rev;
      return adjMargin * 100;
    } else {
      return 0;
    }
  };

  const getAssetAdjustments = () => {
    if (projectTotals) {
      let vendAdj = 0;
      if (projectTotals.vendor_asset_totals) {
        projectTotals.vendor_asset_totals.forEach((v) => {
          vendAdj = vendAdj + v.credits - v.debits;
        });
      }
      const adj =
        projectTotals.project_asset_totals.customer_debits -
        projectTotals.project_asset_totals.customer_credits +
        vendAdj;
      return adj;
    } else {
      return 0;
    }
  };

  const getAssetMargin = () => {
    const adj = getAssetAdjustments();
    const adjProfit = projectTotals.project_asset_totals.profit + adj;
    if (projectTotals.project_asset_totals.total_rev !== 0 && adjProfit !== 0) {
      const adjMargin =
        adjProfit / projectTotals.project_asset_totals.total_rev;
      return adjMargin * 100;
    } else {
      return 0;
    }
  };
  console.log(projectTotals)
  return (
    projectTotals && (
      <div className="col">
        <div className="p-2 border text-center project-card">
          {projectTotals && (
            <div className="project-card-list">
              <h5>Calculated Freight Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Freight Rev</th>
                    <th>Freight Cost</th>
                    <th>FSC Rev</th>
                    <th>FSC Cost</th>
                    <th>Sand Rev</th>
                    <th>Sand Cost</th>
                    <th>Total Rev</th>
                    <th>Total Cost</th>
                    <th>Adjustments</th>
                    <th>Profit</th>
                    <th>Profit Margin</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      $
                      {projectTotals.project_totals.freight_rev.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.freight_cost.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.fsc_rev.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.fsc_cost.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.sand_rev.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.sand_cost.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.total_rev.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.total_cost.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {getFreightAdjustments().toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td>
                      $
                      {(
                        projectTotals.project_totals.profit +
                        getFreightAdjustments()
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td>{getFreightMargin().toFixed(2)}%</td>
                  </tr>
                </tbody>
              </table>
              <h5>Customer Freight Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Invoiced Loads</th>
                    <th>Remaining Loads</th>
                    <th>Invoiced (tons)</th>
                    <th>Remaining (tons)</th>
                    <th>Total Invoiced</th>
                    <th>Remaining to Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {
                        projectTotals.project_totals
                          .customer_total_freight_loads
                      }
                    </td>
                    <td>
                      {
                        projectTotals.project_totals
                          .customer_remaining_frieght_loads
                      }
                    </td>
                    <td>
                      {projectTotals.project_totals.customer_total_freight_weight.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      {projectTotals.project_totals.customer_remaining_freight_weight_tons.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.customer_total_freight_inv.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.customer_remaining_freight_inv.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5>Customer Sand Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Invoiced Loads</th>
                    <th>Remaining Loads</th>
                    <th>Invoiced (tons)</th>
                    <th>Remaining (tons)</th>
                    <th>Total Invoiced</th>
                    <th>Remaining to Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {projectTotals.project_totals.customer_total_sand_loads}
                    </td>
                    <td>
                      {
                        projectTotals.project_totals
                          .customer_remaining_sand_loads
                      }
                    </td>
                    <td>
                      {projectTotals.project_totals.customer_total_sand_weight.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      {projectTotals.project_totals.customer_remaining_sand_weight_tons.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.customer_total_sand_inv.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                    <td>
                      $
                      {projectTotals.project_totals.customer_remaining_sand_inv.toLocaleString(
                        "en-US",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5>Vendor Freight Invoiced Totals</h5>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Invoiced Loads</th>
                    <th>Canceled Loads</th>
                    <th>Remaining Loads</th>
                    <th>Invoiced (tons)</th>
                    <th>Remaining (tons)</th>
                    <th>Total Invoiced</th>
                    <th>Remaining to Invoice</th>
                    <th>Credit to Us</th>
                    <th>Charge to Vendor</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {projectTotals.vendor_totals &&
                    projectTotals.vendor_totals.map(
                      (v, idx) =>
                        !v.is_sand && (
                          <tr key={idx}>
                            <td>{v.vendor_name}</td>
                            <td>{v.invoiced_loads}</td>
                            <td>{v.vendor_canceled_load_count}</td>
                            <td>{v.remaining_loads}</td>
                            <td>
                              {v.invoiced_weight.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td>
                              {v.remaining_weight.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td>
                              $
                              {v.total_invoiced.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td>
                              $
                              {v.remaining_to_invoice.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td>
                              $
                              {v.credits.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td>
                              $
                              {v.debits.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td>
                              $
                              {(
                                v.remaining_to_invoice -
                                v.debits +
                                v.credits
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          </tr>
                        ),
                    )}
                  {allVendorTotals && (
                    <tr key={"all_vendor_totals"}>
                      <td className="td-totals-xl">Totals</td>
                      <td className="td-totals-xl">{allVendorTotals.invoiced_loads}</td>
                      <td className="td-totals-xl"></td>
                      <td className="td-totals-xl">{allVendorTotals.remaining_loads}</td>
                      <td className="td-totals-xl">
                        {allVendorTotals.invoiced_weight.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="td-totals-xl">
                        {allVendorTotals.remaining_weight.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="td-totals-xl">
                        $
                        {allVendorTotals.total_invoiced.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="td-totals-xl">
                        $
                        {allVendorTotals.remaining_to_invoice.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="td-totals-xl"></td>
                      <td className="td-totals-xl"></td>
                      <td className="td-totals-xl"></td>
                    </tr>
                  )}
                </tbody>
              </table>
              {projectSandRates && (
                <>
                  <h5>Vendor Sand Invoiced Totals</h5>
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>PO</th>
                        <th>Terminal</th>
                        <th>Invoiced Loads</th>
                        <th>Canceled Loads</th>
                        <th>Remaining Loads</th>
                        <th>Remaining (tons)</th>
                        <th>Total Invoiced</th>
                        <th>Remaining to Invoice</th>
                        <th>Credit to Us</th>
                        <th>Charge to Us</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projectTotals.vendor_totals &&
                        projectTotals.vendor_totals.map(
                          (v, idx) =>
                            v.is_sand && (
                              <tr key={idx}>
                                <td>{v.po_number}</td>
                                <td>{getTerminalName(v.po_number)}</td>
                                <td>{v.invoiced_loads}</td>
                                <td>{v.vendor_canceled_load_count}</td>
                                <td>{v.remaining_loads}</td>
                                <td>
                                  {v.remaining_weight.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {v.total_invoiced.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {v.remaining_to_invoice.toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                </td>
                                <td>
                                  $
                                  {v.credits.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {v.debits.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {(
                                    v.remaining_to_invoice -
                                    v.debits +
                                    v.credits
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                              </tr>
                            ),
                        )}
                    </tbody>
                  </table>
                </>
              )}
              {projectTotals.project_asset_totals && projectAssetLoads && (
                <>
                  <h5>Calculated Asset Totals</h5>
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Loads</th>
                        <th>Freight Rev</th>
                        <th>Freight Cost</th>
                        <th>FSC Rev</th>
                        <th>FSC Cost</th>
                        <th>Total Rev</th>
                        <th>Total Cost</th>
                        <th>Adjustments</th>
                        <th>Profit</th>
                        <th>Profit Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {
                            projectTotals.project_asset_totals
                              .total_freight_loads
                          }
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.freight_rev.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.freight_cost.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.fsc_rev.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.fsc_cost.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.total_rev.toLocaleString(
                            "en-US",
                          )}
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.total_cost.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td>
                          $
                          {getAssetAdjustments().toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td>
                          $
                          {(
                            projectTotals.project_asset_totals.profit +
                            getAssetAdjustments()
                          ).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td>{getAssetMargin().toFixed(2)}%</td>
                      </tr>
                    </tbody>
                  </table>
                  <h5>Customer Asset Invoiced Totals</h5>
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Invoiced Loads</th>
                        <th>Remaining Loads</th>
                        <th>Total Invoiced</th>
                        <th>Remaining to Invoice</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {
                            projectTotals.project_asset_totals
                              .customer_total_freight_loads
                          }
                        </td>
                        <td>
                          {
                            projectTotals.project_asset_totals
                              .customer_remaining_frieght_loads
                          }
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.customer_total_freight_inv.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td>
                          $
                          {projectTotals.project_asset_totals.customer_remaining_freight_inv.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}
              {projectTotals.vendor_asset_totals && projectAssetLoads && (
                <>
                  <h5>Vendor Asset Invoiced Totals</h5>
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Vendor</th>
                        <th>Invoiced Loads</th>
                        <th>Remaining Loads</th>
                        <th>Total Invoiced</th>
                        <th>Remaining to Invoice</th>
                        <th>Credit to Us</th>
                        <th>Charge to Us</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projectTotals.vendor_asset_totals &&
                        projectTotals.vendor_asset_totals.map(
                          (v, idx) =>
                            !v.is_sand && (
                              <tr key={idx}>
                                <td>{v.vendor_name}</td>
                                <td>{v.invoiced_loads}</td>
                                <td>{v.remaining_loads}</td>
                                <td>
                                  $
                                  {v.total_invoiced.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {v.remaining_to_invoice.toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                </td>
                                <td>
                                  $
                                  {v.credits.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {v.debits.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  $
                                  {(
                                    v.remaining_to_invoice -
                                    v.debits +
                                    v.credits
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                              </tr>
                            ),
                        )}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    )
  );
}
